export type ReceiverInput<T> = AsyncGenerator<T>
